export const Authorization = 'Authorization';
export const Token = 'token';
export const UserInfo = 'userInfo';
export const chunkCheckedList = 'chunkCheckedList';
export const isGridLayoutVal = 'isGridLayoutVal';
